import { Config } from '@features/auth/shared/components/ng-otp-input/config';

export const INPUT_VERIFY_CODE_CONFIG: Config = {
  length: 6,
  allowNumbersOnly: true,
  placeholder: '_',
  containerClass: 'form-group',
};
